export enum Route {
    NutritionStatements = "nutrition-statements",
}
